module.exports = __webpack_public_path__ + "media/images/logo@2x-02d28edc728834133ffaa34acb3af2ea.png";